import CloudBotsSlice from './cloudBots.slice';

export const { actions: cloud_bots_actions } = CloudBotsSlice;

export default CloudBotsSlice.reducer;
